/*!
 * Take data out of arrays if the array length is 1
 */
const formatData = data => {

  if (
    Array.isArray( data ) &&
    data.length === 1
  )
    return formatData( data[ 0 ] )

  let keys

  if ( typeof data === 'object' && data !== null ) {
    if ( Array.isArray( data ) )
      keys = [ ...Array( data.length ).keys() ]
    else
      keys = Object.keys( data )

    keys.forEach( key => {
      data[ key ] = formatData( data[ key ] )
    } )

    return data
  }
  else
    return data

}

export default data => formatData( data )
